import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { authReducer } from "./reducer";
import {
  loginUserAction,
  logoutUserAction,
  getUserProfileAction,
  updatePasswordAction,
  getAllUserAction,
  getAllClientsAction,
  getIndividualClientsAction,
  assignClientsToUserAction,
  getAssignedClientsToUserAction,
  getAllFinacUsersAction,
  changeFinacFirstLastNameAction,
  changeFinacUserPasswordAction,
  changeUserStatusAction,
  forgetPasswordAction,
  resetForgetPasswordAction,
  loginWithMobileNumberAction,
  loginWithMobileOtpVerifyAction,
  userProfileAction,
  // updateProfile,
  getAllAssignUserOfSingleClientAction,
  getAllFinacClientUsersAction,
  getAllFinacClientsAction,
  addRemoveToFavouriteAction,
  // addUserPofile,
  unassignedUserOfSingleClient,
  checkUniqueEmailAction,
  checkUniqueMobileNoAction,
  getFinacInternalUsersAction,
  getFinacExternalUsersAction,
  getAllFinacManagerAction,
  getAllFinacPartnerAction,
  getAttendanceDataAction,
  addAttendanceTimeAction,
  checkRecruitmentTrackerUniqueEmailAction,
  checkRecruitmentTrackerUniqueMobileNoAction,
  checkUniqueEmailSignUpAction,
  checkUniqueMobileNoSignUpAction,
  getAllCountrySignUpAction,
  getAllCitySignUpAction,
  getAllStateSignUpAction,
  getTeamDirectoryUserListAction,
  getOtpSignUpAction,
  signUpOtpVerifyAction,
  getAllFinacGovtOfficerAction,
  getGovtOfficerJobsListAction,
  getVerifyAuAccountNumberAction,
  getPincodeAction,
  signUpOtpVerifyVoucherCodeAction,
  createOrderAction,
  verifyPaymentAction,
  signUpClientAction,
  getAccountNoPaymentVoucherAction,

} from "./actions";
import { AuthType, ClientType } from "./authTypes";

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: authReducer,
  extraReducers: {
    [loginUserAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [loginUserAction.fulfilled.toString()]: (state: AuthType, { payload }) => {
      const { success, message, result, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          success: success,
          fetching: false,
          error: message,
          statusCode: status_code,
        };
      }

      let sideMenuList: any = [];
      let moduleList: any = [];
      let othersList: any = [];

      result?.group_menu &&
        result?.group_menu?.all_menu_details?.length > 0 &&
        result?.group_menu?.all_menu_details.map((menu: any) => {
          menu?.category === "side_menu"
            ? sideMenuList.push(menu)
            : menu?.category === "others"
              ? othersList.push(menu)
              : moduleList.push(menu);
        });

      let allMenus = result?.group_menu?.all_group_menu;
      return {
        ...state,
        fetching: false,
        token: result.user_token,
        loginData: result,
        statusCode: status_code,
        sideMenus: sideMenuList,
        modules: moduleList,
        allGroupMenus: allMenus,
        others: othersList,
      };
    },
    [loginUserAction.rejected.toString()]: (state: AuthType, { errors }) => ({
      ...state,
      fetching: false,
    }),
    [loginWithMobileOtpVerifyAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [loginWithMobileOtpVerifyAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      let sideMenuList: any = [];
      let moduleList: any = [];

      result?.group_menu &&
        result?.group_menu?.all_menu_details?.length > 0 &&
        result?.group_menu?.all_menu_details.map((menu: any) => {
          menu?.category === "side_menu"
            ? sideMenuList.push(menu)
            : moduleList.push(menu);
        });

      let allMenus = result?.group_menu?.all_group_menu;

      if (success === 0) {
        return {
          ...state,
          success: success,
          fetching: false,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        token: result.user_token,
        loginData: result,
        statusCode: status_code,
        sideMenus: sideMenuList,
        modules: moduleList,
        allGroupMenus: allMenus,
        message: message,
      };
    },
    [loginWithMobileOtpVerifyAction.rejected.toString()]: (
      state: AuthType,
      { errors }
    ) => ({
      ...state,
      fetching: false,
      error: errors.message,
    }),
    [loginWithMobileNumberAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [loginWithMobileNumberAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          success: success,
          fetching: false,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        message: message,
        success: success,
      };
    },
    [loginWithMobileNumberAction.rejected.toString()]: (
      state: AuthType,
      { errors }
    ) => ({
      ...state,
      fetching: false,
      error: errors.message,
    }),
    [logoutUserAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [logoutUserAction.fulfilled.toString()]: (state: AuthType, { payload }) => {
      const { success, message, result } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        token: null,
      };
    },
    [logoutUserAction.rejected.toString()]: (state: AuthType, { error }) => ({
      ...state,
      fetching: false,
      error: error.message,
    }),
    [forgetPasswordAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [forgetPasswordAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, message, result } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          success: success,
        };
      }

      return {
        ...state,
        fetching: false,
        success: success,
        resetPasswordToken: result.Temp_User_token,
      };
    },
    [forgetPasswordAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error.message,
    }),
    [resetForgetPasswordAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [resetForgetPasswordAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
      };
    },
    [resetForgetPasswordAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
    }),
    [getUserProfileAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [getUserProfileAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, message, result = {}, status_code } = payload;
      const { data, user_type } = result;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        userProfiledata: data,
        userType: user_type,
        statusCode: 401,
      };
    },

    [getAllUserAction.rejected.toString()]: (state: any, { errors }) => ({
      ...state,
      fetching: false,
      // error: errors[0]
    }),
    [getAllUserAction.pending.toString()]: (state: any) => ({
      ...state,
      fetching: true,
    }),
    [getAllUserAction.fulfilled.toString()]: (state: any, { payload }) => {
      const { success, message, result = {}, status_code } = payload;
      const { data, total_count } = result;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          userDetails: result,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        userDetails: data,
        totalUserCount: total_count,
      };
    },

    [getUserProfileAction.rejected.toString()]: (
      state: AuthType,
      { errors }
    ) => ({
      ...state,
      fetching: false,
      // error: errors[0]
    }),

    [userProfileAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [userProfileAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          success,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        userProfileAllData: result,
        persistUserProfileAllData: result,
        statusCode: status_code,
        message,
      };
    },
    [userProfileAction.rejected.toString()]: (state: AuthType, { error }) => ({
      ...state,
      fetching: false,
      error: error,
    }),

    //   [updateProfile.pending.toString()]: (state: AuthType) => ({
    //   ...state,
    //   fetching: true
    // }),
    // [updateProfile.fulfilled.toString()]: (state: AuthType, { payload }) => {
    // const { success, message, result = {}, status_code } = payload;

    //   if (success === 0) {
    //     return {
    //       ...state,
    //       fetching: false,
    //       error: message,
    //       result,
    //       success,

    //     }
    //   }
    //   return {
    //       ...state,
    //     fetching: false,
    //     success,
    //     statusCode: status_code,
    //     message

    //   }
    // },
    // [updateProfile.rejected.toString()]: (state: AuthType, { error }) =>({
    //   ...state,
    //    fetching: false,
    //   success:0,
    //   error:error?.message,
    // }),

    // [addUserPofile.pending.toString()]: (state: AuthType) => ({
    //   ...state,
    //   fetching: true
    // }),
    // [addUserPofile.fulfilled.toString()]: (state: AuthType, { payload }) => {
    // const { success, message, result = {}, status_code } = payload;

    //   if (success === 0) {
    //     return {
    //       ...state,
    //       fetching: false,
    //       error: message,
    //       result,
    //       success,
    //       statusCode: status_code,
    //     }
    //   }
    //   return {
    //       ...state,
    //     fetching: false,
    //     success,
    //     statusCode: status_code,
    //     message

    //   }
    // },
    // [addUserPofile.rejected.toString()]: (state: AuthType, { error }) =>({
    //   ...state,
    //    fetching: false,
    //   success:0,
    //   error:error?.message,
    // }),
    [checkUniqueEmailAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      emailFetching: true,
    }),
    [checkUniqueEmailAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, is_duplicate, message, status_code } = payload?.data;

      if (success === 0) {
        return {
          ...state,
          emailSuccess: success,
          emailFetching: false,
          emailError: message,
          emailSatusCode: status_code,
          isEmail: is_duplicate,
        };
      }
      return {
        ...state,
        isEmail: is_duplicate,
        emailFetching: false,
        emailMessage: message,
        emailSatusCode: status_code,
        emailSuccess: success,
      };
    },
    [checkUniqueEmailAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      emailFetching: false,
      emailSuccess: 0,
      emailError: error?.message,
    }),
    [checkRecruitmentTrackerUniqueEmailAction.pending.toString()]: (
      state: AuthType
    ) => ({
      ...state,
      recruitmentTrackerUniqueEmailFetching: true,
    }),
    [checkRecruitmentTrackerUniqueEmailAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, is_duplicate, message, status_code } = payload?.data;

      if (success === 0) {
        return {
          ...state,
          emailSuccess: success,
          recruitmentTrackerUniqueEmailFetching: false,
          emailError: message,
        };
      }
      return {
        ...state,
        recruitmentTrackerUniqueEmailFetching: false,
        recruitmentTrackerUniqueEmailMessage: message,
      };
    },
    [checkRecruitmentTrackerUniqueEmailAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      recruitmentTrackerUniqueEmailFetching: false,
      emailSuccess: 0,
      emailError: error?.message,
    }),
    [checkRecruitmentTrackerUniqueMobileNoAction.pending.toString()]: (
      state: AuthType
    ) => ({
      ...state,
      recruitmentTrackerUniqueMobileFetching: true,
    }),
    [checkRecruitmentTrackerUniqueMobileNoAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, is_duplicate, message, status_code } = payload?.data;

      if (success === 0) {
        return {
          ...state,
          emailSuccess: success,
          recruitmentTrackerUniqueMobileFetching: false,
          emailError: message,
        };
      }
      return {
        ...state,
        recruitmentTrackerUniqueMobileFetching: false,
        recruitmentTrackerUniqueMobileMessage: message,
      };
    },
    [checkRecruitmentTrackerUniqueMobileNoAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      recruitmentTrackerUniqueMobileFetching: false,
      emailSuccess: 0,
      emailError: error?.message,
    }),
    [checkUniqueMobileNoAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      mobileFetching: true,
    }),
    [checkUniqueMobileNoAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, is_duplicate, message, status_code } = payload?.data;

      if (success === 0) {
        return {
          ...state,
          mobileSuccess: success,
          mobileFetching: false,
          mobileError: message,
          mobileSatusCode: status_code,
          isMobileNo: is_duplicate,
        };
      }
      return {
        ...state,
        isMobileNo: is_duplicate,
        mobileFetching: false,
        mobileMessage: message,
        mobileSatusCode: status_code,
        mobileSuccess: success,
      };
    },
    [checkUniqueMobileNoAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      mobileFetching: false,
      mobileSuccess: 0,
      error: error?.message,
    }),
    [updatePasswordAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [updatePasswordAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, message, result = {}, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          result,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
      };
    },
    [updatePasswordAction.rejected.toString()]: (
      state: AuthType,
      { errors }
    ) => ({
      ...state,
      fetching: false,
      // error: errors[0]
    }),
    [getAllClientsAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [getAllClientsAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, message, result = {}, status_code } = payload;
      const { data = {}, total_count } = ({} = result);

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          error: message,
          success: 0,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        clientList: data,
        totalClientsCount: total_count,
      };
    },
    [getAllClientsAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      fetching: false,
    }),
    [getAllAssignUserOfSingleClientAction.pending.toString()]: (
      state: AuthType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllAssignUserOfSingleClientAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        allAssignUserOfSingleClient: result,
      };
    },
    [getAllAssignUserOfSingleClientAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      fetching: false,
    }),
    [unassignedUserOfSingleClient.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [unassignedUserOfSingleClient.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          error: message,
          success: 0,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
      };
    },
    [unassignedUserOfSingleClient.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      fetching: false,
    }),
    [getIndividualClientsAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [getIndividualClientsAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, status_code, message, result = [] } = payload;

      let finalIds: any[] = [];
      result?.filter((item: any) => {
        finalIds.push(item.client_id);
      });

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        individualClientList: result,
        clientCodeList: finalIds,
      };
    },
    [getIndividualClientsAction.rejected.toString()]: (
      state: AuthType,
      { errors }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: errors?.message,
    }),
    [assignClientsToUserAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [assignClientsToUserAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, status_code, result = {}, message } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
      };
    },
    [assignClientsToUserAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
    }),
    [getAssignedClientsToUserAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [getAssignedClientsToUserAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, status_code, result, message } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        assignedClientsToUserList: result?.data,
        favouriteClientsData: result?.fav_client_data,
        unFavouriteClientsData: result?.unfav_client_data,
        totalUnfavouriteClient: result?.total_unfav_count,
      };
    },
    [getAssignedClientsToUserAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
    }),
    [getAllFinacUsersAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [getAllFinacUsersAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, status_code, result, message } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        finacUsersList: result,
        totalUserCount: result?.total_count,
      };
    },
    [getAllFinacUsersAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
    }),
    [getAllFinacManagerAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      managerFetching: true,
    }),
    [getAllFinacManagerAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, status_code, result, message } = payload;
      if (success === 0) {
        return {
          ...state,
          managerFetching: false,
          managerSuccess: success,
          managerStatusCode: status_code,
          managerError: message,
        };
      }

      return {
        ...state,
        managerFetching: false,
        managerStatusCode: status_code,
        finacManagerList: result?.data,
        totalManagerCount: result?.total_count,
      };
    },
    [getAllFinacManagerAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      managerFetching: false,
      managerError: error?.message,
    }),
    [getAllFinacPartnerAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      partnerFetching: true,
    }),
    [getAllFinacPartnerAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, status_code, result, message } = payload;
      if (success === 0) {
        return {
          ...state,
          partnerFetching: false,
          partnerSuccess: success,
          partnerStatusCode: status_code,
          partnerError: message,
        };
      }

      return {
        ...state,
        partnerFetching: false,
        partnerStatusCode: status_code,
        finacPartnerList: result?.data,
        totalPartnerCount: result?.total_count,
      };
    },
    [getAllFinacPartnerAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      partnerFetching: false,
      partnerError: error?.message,
    }),

    [getAllFinacGovtOfficerAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      gotvOfficerFetching: true,
    }),
    [getAllFinacGovtOfficerAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, status_code, result, message } = payload;
      if (success === 0) {
        return {
          ...state,
          gotvOfficerFetching: false,
          govtOfficerSuccess: success,
          govtOfficerStatusCode: status_code,
          govtOfficerError: message,
        };
      }

      return {
        ...state,
        gotvOfficerFetching: false,
        govtOfficerStatusCode: status_code,
        finacGovtOfficerList: result?.data,
        totalGovtOfficerCount: result?.total_count
      };
    },
    [getAllFinacGovtOfficerAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      gotvOfficerFetching: false,
      govtOfficerError: error?.message,
    }),



    // finacPartnerList
    [getFinacInternalUsersAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      internalFetching: true,
    }),
    [getFinacInternalUsersAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, status_code, result, message } = payload;
      if (success === 0) {
        return {
          ...state,
          internalFetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        internalFetching: false,
        statusCode: status_code,
        internalUsersList: result?.data,
        internalUserCount: result?.total_count,
      };
    },
    [getFinacInternalUsersAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      internalFetching: false,
      error: error?.message,
    }),
    [getFinacExternalUsersAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      externalFetching: true,
    }),
    [getFinacExternalUsersAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, status_code, result, message } = payload;
      if (success === 0) {
        return {
          ...state,
          externalFetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        externalFetching: false,
        statusCode: status_code,
        externalUsersList: result?.data,
        externalUserCount: result?.total_count,
      };
    },
    [getFinacExternalUsersAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      externalFetching: false,
      error: error?.message,
    }),
    [getAllFinacClientsAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [getAllFinacClientsAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, status_code, result, message } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        finacClientsList: result,
      };
    },
    [getAllFinacClientsAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
    }),
    [getAllFinacClientUsersAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [getAllFinacClientUsersAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, status_code, result, message } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        finacClientUsersList: result,
      };
    },
    [getAllFinacClientUsersAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
    }),
    [changeFinacUserPasswordAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [changeFinacUserPasswordAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
      };
    },
    [changeFinacUserPasswordAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
    }),
    [changeFinacFirstLastNameAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [changeFinacFirstLastNameAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
      };
    },
    [changeFinacFirstLastNameAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
    }),
    [changeUserStatusAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [changeUserStatusAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
      };
    },
    [changeUserStatusAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [addRemoveToFavouriteAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [addRemoveToFavouriteAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        message: message,
      };
    },
    [addRemoveToFavouriteAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [addAttendanceTimeAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      attendenceFetching: true,
    }),
    [addAttendanceTimeAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;
      if (success === 0) {
        return {
          ...state,
          attendenceFetching: false,
          attendenceSuccess: success,
          attendanceStatusCode: status_code,
          attendenceError: message,
        };
      }

      return {
        ...state,
        attendenceFetching: false,
        attendenceSuccess: success,
        attendanceStatusCode: status_code,
        message: message,
      };
    },
    [addAttendanceTimeAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      attendenceFetching: false,
      attendenceSuccess: 0,
      attendenceError: error?.message,
    }),
    [getAttendanceDataAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      attendenceFetching: true,
    }),
    [getAttendanceDataAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, status_code, message, result } = payload;
      if (success === 0) {
        return {
          ...state,
          attendenceFetching: false,
          attendenceSuccess: success,
          statusCode: status_code,
          attendenceError: message,
        };
      }

      return {
        ...state,
        attendenceFetching: false,
        attendenceSuccess: success,
        statusCode: status_code,
        message: message,
        attendenceData: result?.response,
        totalAttendanceHours: result?.total_time,
      };
    },
    [getAttendanceDataAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      attendenceFetching: false,
      attendenceSuccess: 0,
      attendenceError: error?.message,
    }),

    // signup

    [checkUniqueEmailSignUpAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      signUpEmailFetching: true,
    }),
    [checkUniqueEmailSignUpAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, is_duplicate, message, status_code } = payload?.data;

      if (success === 0) {
        return {
          ...state,
          signUpEmailSuccess: success,
          signUpEmailFetching: false,
          signUpEmailError: message,
          signUpEmailSatusCode: status_code,
          isSignupEmail: is_duplicate,
        };
      }
      return {
        ...state,
        isSignupEmail: is_duplicate,
        signUpEmailFetching: false,
        signUpEmailMessage: message,
        signUpEmailSatusCode: status_code,
        signUpEmailSuccess: success,
      };
    },
    [checkUniqueEmailSignUpAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      signUpEmailFetching: false,
      signUpEmailSuccess: 0,
      signUpEmailError: error?.message,
    }),


    [checkUniqueMobileNoSignUpAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      signUpMobileFetching: true,
    }),
    [checkUniqueMobileNoSignUpAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, is_duplicate, message, status_code } = payload?.data;

      if (success === 0) {
        return {
          ...state,
          signUpMobileSuccess: success,
          signUpMobileFetching: false,
          signUpMobileError: message,
          signUpMobileSatusCode: status_code,
          isSignUpMobileNo: is_duplicate,
        };
      }
      return {
        ...state,
        isSignUpMobileNo: is_duplicate,
        signUpMobileFetching: false,
        singUpMobileMessage: message,
        signUpMobileSatusCode: status_code,
        signUpMobileSuccess: success,
      };
    },
    [checkUniqueMobileNoSignUpAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      signUpMobileFetching: false,
      signUpMobileSuccess: 0,
      error: error?.message,
    }),


    // sign up country


    [getAllCountrySignUpAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      countryFetching: true,
    }),
    [getAllCountrySignUpAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, message, result, status_code, count } = payload;

      if (success === 0) {
        return {
          ...state,
          countryFetching: false,
          countrySuccess: success,
          statusCode: status_code,
          countryError: message,
        };
      }

      return {
        ...state,
        countryFetching: false,
        statusCode: status_code,
        countryList: result,
        countrySuccess: success,
        countryListTotalCount: count ? count : 0,
      };
    },
    [getAllCountrySignUpAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      countryFetching: false,
      countrySuccess: 0,
      countryError: error?.message,
    }),

    // state
    [getAllStateSignUpAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      stateFetching: true,
    }),
    [getAllStateSignUpAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, message, result, status_code, count, is_state } =
        payload;

      if (success === 0) {
        return {
          ...state,
          stateFetching: false,
          stateSuccess: success,
          statusCode: status_code,
          stateError: message,
        };
      }

      return {
        ...state,
        stateFetching: false,
        statusCode: status_code,
        stateList: result,
        stateSuccess: success,
        stateListTotalCount: count,
        isState: is_state,
      };
    },
    [getAllStateSignUpAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      stateFetching: false,
      stateSuccess: 0,
      stateError: error?.message,
    }),


    [getAllCitySignUpAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      countryFetching: true,
    }),
    [getAllCitySignUpAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, message, result, status_code, count, is_city } = payload;

      if (success === 0) {
        return {
          ...state,
          countryFetching: false,
          citySuccess: success,
          statusCode: status_code,
          cityError: message,
        };
      }

      return {
        ...state,
        countryFetching: false,
        statusCode: status_code,
        cityList: result,
        citySuccess: success,
        cityListTotalCount: count ? count : 0,
        isCity: is_city,
      };
    },
    [getAllCitySignUpAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      countryFetching: false,
      citySuccess: 0,
      cityError: error?.message,
    }),
    [signUpClientAction.pending.toString()]: (state: AuthType) => {
      {
        return {
          ...state,
          fetching: true,
        }


      }
    },
    [signUpClientAction.fulfilled.toString()]: (state: AuthType, { payload }) => {

      const { success, message, result, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          success: success,
          fetching: false,
          error: message,
          statusCode: status_code,
        };
      }

      let sideMenuList: any = [];
      let moduleList: any = [];
      let othersList: any = [];

      result?.group_menu &&
        result?.group_menu?.all_menu_details?.length > 0 &&
        result?.group_menu?.all_menu_details.map((menu: any) => {
          menu?.category === "side_menu"
            ? sideMenuList.push(menu)
            : menu?.category === "others"
              ? othersList.push(menu)
              : moduleList.push(menu);
        });

      let allMenus = result?.group_menu?.all_group_menu;
      return {
        ...state,
        fetching: false,
        token: result.user_token,
        loginData: result,
        statusCode: status_code,
        sideMenus: sideMenuList,
        modules: moduleList,
        allGroupMenus: allMenus,
        others: othersList,
      };
    },
    [signUpClientAction.rejected.toString()]: (state: AuthType, { errors }) => {
      {
        return {
          ...state,
          fetching: false,
        }

      }
    },
    // get otp verify otp


    // TEAM DIRECTORY

    [getTeamDirectoryUserListAction.pending.toString()]:
      (state: AuthType) => ({
        ...state,
        fetching: true,
      }),
    [getTeamDirectoryUserListAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, status_code, result, message, total_count } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        teamDirectoryUsersData: result,
        totalTeamDirectoryUsersCount: total_count,
      };
    },
    [getTeamDirectoryUserListAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
    }),

    [getOtpSignUpAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [getOtpSignUpAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          success: success,
          fetching: false,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        message: message,
        success: success,
      };
    },
    [getOtpSignUpAction.rejected.toString()]: (
      state: AuthType,
      { errors }
    ) => ({
      ...state,
      fetching: false,
      error: errors?.message,
    }),


    [signUpOtpVerifyAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [signUpOtpVerifyAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          success: success,
          fetching: false,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        message: message,
        success: success,
      };
    },
    [signUpOtpVerifyAction.rejected.toString()]: (
      state: AuthType,
      { errors }
    ) => ({
      ...state,
      fetching: false,
      error: errors.message,
    }),

    [getGovtOfficerJobsListAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),

    [getGovtOfficerJobsListAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, status_code, result, message, total_count } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        totalJobListCount: total_count,
        govtOfficerJobsList: result,
      };
    },

    [getGovtOfficerJobsListAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
    }),


    // au
    [getVerifyAuAccountNumberAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      auAccountNumberFetching: true,
    }),
    [getVerifyAuAccountNumberAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, message, result, status_code, count, is_state } =
        payload;

      if (success === 0) {
        return {
          ...state,
          auAccountNumberFetching: false,
          success: success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        auAccountNumberFetching: false,
        statusCode: status_code,
        auAccountNumberVerifyData: result?.data,
        isAccountNumberVerified: result?.data?.account_exists,
        verifyAccountNumberMessage: result?.data?.message,


        success: success,
      };
    },
    [getVerifyAuAccountNumberAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      auAccountNumberFetching: false,
      success: 0,
      error: error?.message,
      verifyAccountNumberMessage: error?.message
    }),
    // 
    [getPincodeAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [getPincodeAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, message, result, status_code, count, is_state } =
        payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        specificPincodeInformation: result,
        success: success,
      };
    },
    [getPincodeAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [getAccountNoPaymentVoucherAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [getAccountNoPaymentVoucherAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, message, result, status_code } =
        payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: success,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        accountPaymentVoucherVerification: result,
        success: success,
      };
    },
    [getAccountNoPaymentVoucherAction.rejected.toString()]: (
      state: AuthType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    // verify voucher code

    [signUpOtpVerifyVoucherCodeAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [signUpOtpVerifyVoucherCodeAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, message, status_code, result } = payload;
      if (success === 0) {
        return {
          ...state,
          verifyVoucherSuccess: success,
          fetching: false,
          verifyVoucherMessage: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        verifyVoucherMessage: message,
        verifyVoucherSuccess: success,
        isVoucherCodeVerified: result?.voucher_code_verified
      };
    },
    [signUpOtpVerifyVoucherCodeAction.rejected.toString()]: (
      state: AuthType,
      { errors }
    ) => ({
      ...state,
      fetching: false,
      verifyVoucherMessage: errors.message,
    }),

    [createOrderAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [createOrderAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          success: success,
          fetching: false,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        message: message,
        success: success,
      };
    },
    [createOrderAction.rejected.toString()]: (
      state: AuthType,
      { errors }
    ) => ({
      ...state,
      fetching: false,
      error: errors.message,
    }),

    [verifyPaymentAction.pending.toString()]: (state: AuthType) => ({
      ...state,
      fetching: true,
    }),
    [verifyPaymentAction.fulfilled.toString()]: (
      state: AuthType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          success: success,
          fetching: false,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        message: message,
        success: success,
      };
    },
    [verifyPaymentAction.rejected.toString()]: (
      state: AuthType,
      { errors }
    ) => ({
      ...state,
      fetching: false,
      error: errors.message,
    })
  },
});

export const {
  resetError: resetAuthError,
  resetSuccess: resetAuthSuccess,
  resetAuthMessage,
  resetSession,
  resetUserDetails,
  resetAuthFetching,
  resetIndividualClientList,
  resetResetPasswordToken,
  resetAllGroupMenuList,
  resetUserProfiledata,
  resetUserProfileAllData,
  resetClientList,
  resetAssignedClientsToUserList,
  resetFinacUsersList,
  resetFinacClientUsersList,
  resetPersistUserProfileAllData,
  resetUnFavouriteClientToUserList,
  resetFavouriteClientToUserList,
  resetAllAssignUserOfSingleClient,
  resetTotalUserCount,
  resetTotalClientsCount,
  resetEmailSuccess,
  resetEmailSatusCode,
  resetEmailError,
  resetEmailMessage,
  resetEmailFetching,
  resetIsEmail,
  resetMobileSuccess,
  resetMobileSatusCode,
  resetMobileError,
  resetMobileMessage,
  resetMobileFetching,
  resetIsMobileNo,
  resetFinacManagerList,
  resetFinacPartnerList,
  resetTotalManagerCount,
  setClientCurrencyDetails,
  resetAttendenceData,
  resetAttendenceError,
  resetAttendenceSuccess,
  setLocationDetails,
  resetLocationDetails,
  resetAttendanceStatusCode,
  resetTotalUnfavouriteClient,
  setCompanyName,
  resetCompanyName,
  resetRecruitmentTrackerUniqueEmailMessage,
  resetRecruitmentTrackerUniqueMobileMessage,
  resetSignUpEmailSuccess,
  resetSignUpEmailSatusCode,
  resetSignUpEmailError,
  resetSignUpEmailMessage,
  resetSignUpEmailFetching,
  resetIsSignupEmail,
  resetSignUpMobileSuccess,
  resetSignUpMobileSatusCode,
  resetSignUpMobileError,
  resetSingUpMobileMessage,
  resetSignUpMobileFetching,
  resetIsSignUpMobileNo,
  resetStateList,
  resetStateListTotalCount,
  resetStateFetching,
  resetCityList,
  resetCityListTotalCount,
  resetCityFetching,
  resetCountryList,
  resetCountryListTotalCount,
  resetTeamDirectoryTotalCount,
  resetTeamDirectoryUsersList,
  resetCountrySuccess,
  resetCountryError,
  resetStateError,
  resetStateSuccess,
  resetCityError,
  resetCitySuccess,
  resetFinacGovtOfficerList,
  resetTotalGovtOfficerCount,
  resetGovtOfficerJobsList,
  resetTotalJobListCount,
  resetAuAccountNumberVerifyData,
  resetspecificPincodeInformation,
  resetVerifyVoucherSuccess,
  resetVerifyVoucherMessage,
  resetIsAccountNumberVerified,
  resetVerifyAccountNumberMessage,
  resetAccountPaymentVoucherVefication,
  resetIsVoucherCodeVerified
} = authSlice.actions;
